export const TYPES = [
  {
    text: 'Feedback',
    value: 'Feedback'
  },
  {
    text: 'Complaint',
    value: 'Complaint'
  },
]

export const CATEGORIES = [
  {
    text: 'Technical',
    value: 1
  },
  {
    text: 'Non Technical',
    value: 1
  },
]

export const TRANSPORTERS = [
  {
    text: 'Transporters',
    value: 1
  },
]

export const PRIORITIES = [
  {
    text: 'Low',
    value: 'Low'
  },
  {
    text: 'Medium',
    value: 'Medium'
  },
  {
    text: 'High',
    value: 'High'
  },
]

export const SETTLEMENT_PROCESS = [
  {
    text: 'Closed by Technical Sales Support',
    value: 'closed_by_technical_sales_supp'
  },
  {
    text: 'Need Follow Up By Sales',
    value: 'need_follow_up_by_sales'
  },
]

export const LIST_QUARTER = [
  {
    text: 'Q1',
    value: 'Q1'
  },
  {
    text: 'Q2',
    value: 'Q2'
  },
  {
    text: 'Q3',
    value: 'Q3'
  },
  {
    text: 'Q4',
    value: 'Q4'
  },
]

export const DASHBOARD_FILTER_RANGETIME = [
  {
    text: 'Quarterly',
    value: 'quarterly'
  },
  {
    text: 'Monthly',
    value: 'monthly'
  },
  {
    text: 'Yearly',
    value: 'yearly'
  }
]
